<template>
  <div class="sighting-filters-summary" v-if="value && hasValue()">
    <h4 class="appliedFilters">Applied Filters</h4>
    <div class="filter-summary-holder">
      <div class="filter-tags filter-tags-vetting">
        <span class="label label--inline" v-if="value.vettableOnly">Vettable Records</span>
        <span class="label label--inline" v-if="value.pendingOnly">Pending Records</span>
      </div>
      <dl v-if="value.selectedTaxons && value.selectedTaxons.length != 0">
        <dt>Taxon(s)</dt>
        <dd class="falseCSV">
          <span class="filter-value-rep filter-value-rep-taxon notranslate" translate="no" v-for="taxon in value.selectedTaxons">{{taxon.common_name}}<br /><small><em>{{taxon.scientific_name}}</em></small></span>
        </dd>
      </dl>
      <dl v-if="value.selectedLocations && value.selectedLocations.length != 0">
        <dt>Location(s)</dt>
        <dd class="falseCSV">
          <span class="filter-value-rep notranslate" translate="no" v-for="location in value.selectedLocations">{{location.display_name}}</span>
        </dd>
      </dl>
      <dl v-if="!value.pendingOnly && value.selectedStatuses && value.selectedStatuses.length != 0">
        <dt>Status(es)</dt>
        <dd class="falseCSV">
          <span class="filter-value-rep" v-for="status in value.selectedStatuses">{{status.name}}</span>
        </dd>
      </dl>
      <dl v-if="value.selectedRecordTypes && value.selectedRecordTypes.length != 0">
        <dt>Record Type(s)</dt>
        <dd class="falseCSV">
          <span class="filter-value-rep" v-for="recordType in value.selectedRecordTypes">{{recordType.name}}</span>
        </dd>
      </dl>
      <dl v-if="value.selectedConfidences && value.selectedConfidences.length != 0">
        <dt>Observer ID Confidence(s)</dt>
        <dd  class="falseCSV">
          <span class="filter-value-rep" v-for="confidences in value.selectedConfidences">{{confidences.name}}</span>
        </dd>
      </dl>
      <dl v-if="value.selectedLifeStages && value.selectedLifeStages.length != 0">
        <dt>Life Stage(s)</dt>
        <dd  class="falseCSV">
          <span class="filter-value-rep" v-for="stage in value.selectedLifeStages">{{stage.name}}</span>
        </dd>
      </dl>
      <dl v-if="value.selectedUsers && value.selectedUsers.length != 0">
        <dt>User(s)</dt>
        <dd class="falseCSV">
          <span class="filter-value-rep" v-for="user in value.selectedUsers">{{user.display_name}}</span>
        </dd>
      </dl>
      <dl v-if="value.startDate || value.endDate">
        <dt>Date Range</dt>
        <dd>
          <span v-if="value.startDate && !value.endDate">Start: </span>
          <span v-if="value.startDate">{{value.startDate.split('T')[0] | moment(momentDisplayFormat())}}</span>
          <span v-if="value.startDate && value.endDate"> through </span>
          <span v-if="!value.startDate && value.endDate">End: </span>
          <span v-if="value.endDate">{{value.endDate.split('T')[0] | moment(momentDisplayFormat())}}</span>
        </dd>
      </dl>
      <dl v-if="value.startMonth || value.endMonth">
        <dt>Month Range</dt>
        <dd>
          <span v-if="value.startMonth">{{value.startMonth.split('T')[0] | moment("MMMM")}}</span>
          <span v-if="value.startMonth && value.endMonth"> through </span>
          <span v-if="value.endMonth">{{value.endMonth.split('T')[0] | moment("MMMM")}}</span>
        </dd>
      </dl>
      <dl v-if="value.searchID">
        <dt>OC#</dt>
        <dd>{{value.searchID}}</dd>
      </dl>
      <dl v-if="value.selectedVetters && value.selectedVetters.length != 0">
        <dt>Vetter(s)</dt>
        <dd class="falseCSV">
          <span class="filter-value-rep" v-for="vetter in value.selectedVetters">{{vetter.display_name}}</span>
        </dd>
      </dl>
      <dl v-if="value.search && value.search.trim() != ''">
        <dt>Search</dt>
        <dd>
          <em>{{value.search}}</em>
        </dd>
      </dl>
      <dl v-if="value.startVetDate || value.endVetDate">
        <dt>Vetted Date Range</dt>
        <dd>
          <span v-if="value.startVetDate && !value.endVetDate">Start: </span>
          <span v-if="value.startVetDate">{{value.startVetDate.split('T')[0] | moment(momentDisplayFormat())}}</span>
          <span v-if="value.startVetDate && value.endVetDate"> through </span>
          <span v-if="!value.startVetDate && value.endVetDate">End: </span>
          <span v-if="value.endVetDate">{{value.endVetDate.split('T')[0] | moment(momentDisplayFormat())}}</span>
        </dd>
      </dl>
      <div class="filter-tags">
        <span class="label label--inline" v-if="value.excludeDotMap">Dot Map Data Excluded</span>
        <span class="label label--inline" v-if="value.excludeThirdParty">Submitted for Others Excluded</span>
        <span class="label label--inline" v-if="value.includeDeclined">Declined Data Included</span>
        <span class="label label--inline" v-if="value.excludeiNat">iNaturalist Data Excluded</span>
        <span class="label label--inline" v-if="value.highQualityOnly">High Quality Only</span>
        <span class="label label--inline" v-if="value.certifiedOnly">Certified Observers Only</span>
        <span class="label label--inline" v-if="value.outliersOnly">Outliers Only</span>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'SightingFiltersSummary',
    props: ['value'],
    methods:{
      hasValue: function(){
        if (!this.value) {
          return false;
        }
        for (var key in this.value){
          if (key == 'search_fields') {
            continue;
          }
          if (this.value[key] !== false && this.value[key] !== null) {
            return true;
          }
        }
        return false;
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/SightingFiltersSummary.vue